// extracted by mini-css-extract-plugin
export default {"userListSection":"championshipList_userListSection__eh60Y"};